module.exports = __webpack_public_path__ + "static/media/Rysunek7.2fd4f7c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/architektura/Rysunek7.jpg
// module id = 560
// module chunks = 0